import { useEffect } from "react";

import { useRouter } from "next/router";
import ReactPaginate from "react-paginate";
import { useTina } from "tinacms/dist/react";

import { ROUTES } from "@/helpers/routes";
import Layout from "@/shared/components/layout";
import PageSeo from "@/shared/components/PageSeo";
import PostHeroSection from "@/shared/features/posts/PostHeroSection";
import { PostPageNameEnum } from "@/types/posts";
import client from "tina/__generated__/databaseClient";

function Stories(props: any) {
    const router = useRouter();
    const mainPage: any = router.query.page;
    const maindata = useTina({
        query: props.query,
        variables: props.variables,
        data: props.data,
    });
    const storiesList = maindata.data.storiesConnection.edges;
    const itemsPerPage = 4;
    const pageCount = Math.ceil(storiesList.length / itemsPerPage);
    const page: any = !isNaN(mainPage as any) && mainPage !== undefined && mainPage <= pageCount ? +mainPage as any : 1;

    const itemOffset = 4 * (page - 1);
    const endOffset = itemOffset + itemsPerPage;

    const currentItems = storiesList.slice(itemOffset, endOffset);

    useEffect(() => {
        if (router.isReady && mainPage !== undefined && (isNaN(mainPage as any) || mainPage > pageCount)) {
            router.push("/stories");
        }
    }, [router, mainPage, pageCount]);

    const handlePageClick = (selectedItem: any) => {
        let path = "/stories";
        if (selectedItem.selected !== 0) {
            path += `?page=${selectedItem.selected + 1}`;
        }
        router.push(path);
    };

    return (
        <div>
            <PageSeo title="Stories | The Gender Index" pathname={ROUTES.stories} />
            <Layout>
                {
                    ((!isNaN(mainPage as any) || mainPage === undefined || mainPage <= pageCount))
                    && <div className="multipleLayoutWrap">
                        <div className='singleLayout resourcePage'>
                            <h3>
                                Stories
                            </h3>
                            {
                                currentItems.map((post: any) => (
                                    <PostHeroSection
                                        data={post.node}
                                        key={post.node.id}
                                        pageName={PostPageNameEnum.stories}
                                        page={page === 1 ? undefined : page} />
                                ))
                            }
                            <div className='pagination'>
                                <ReactPaginate
                                    nextLabel=">"
                                    nextClassName="next"
                                    onPageChange={handlePageClick}
                                    pageCount={pageCount}
                                    previousLabel="<"
                                    previousClassName="prev"
                                    renderOnZeroPageCount={null}
                                    initialPage={page - 1}
                                    disabledLinkClassName="disableBtn"
                                />
                            </div>
                        </div>

                    </div>
                }
            </Layout>
        </div>
    );
}

export default Stories;

export const getStaticProps = async () => {
    const data = await client.queries.storiesConnection({
        sort: "date_published",
        last: 10000,
    });

    const serializableData = JSON.parse(JSON.stringify(data));

    return {
        props: serializableData,
    };
};
